import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { EmployeeBaseRateService } from '../employee-base-rate.service';
import * as EmployeeBaseRateActions from './employee-base-rate.actions';
import * as fromShared from '../../../shared';
import * as fromDataServices from '../../../data-services';
import * as fromPayrollItemStore from '../../item/store';

@Injectable()
export class EmployeeBaseRateEffects {
    private employeePayrollItemDS: EntityCollectionService<fromDataServices.EmployeePayrollItem.EmployeePayrollItemModel>;
    private employeeDS: EntityCollectionService<fromDataServices.ManageUsers.LoginModel>;

    getEmployeeBaseRates$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EmployeeBaseRateActions.getEmployeeBaseRates),
            switchMap(action =>
                this.service.get(action.activeOnly).pipe(
                    map(dtos => {
                        const rows = dtos || [];
                        return EmployeeBaseRateActions.loadEmployeeBaseRates({
                            rows
                        });
                    }),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );

    putEmployeeBaseRate$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EmployeeBaseRateActions.putEmployeeBaseRate),
            switchMap(action =>
                this.service.put(action.request).pipe(
                    map(resp => {
                        const updated = resp?.Items?.[0];
                        if (updated) {
                            return EmployeeBaseRateActions.upsertEmployeeBaseRate(
                                { row: updated }
                            );
                        }
                        return EmployeeBaseRateActions.getEmployeeBaseRates(
                            true
                        );
                    }),
                    tap(() => {                       
                        this.employeePayrollItemDS.clearCache();
                        this.employeePayrollItemDS.getAll();
                        this.employeeDS.clearCache();
                        this.employeeDS.getWithQuery({
                            ShowInactive: 'true',
                            UserFilterID: '7'
                        });
                        this.store.dispatch(fromPayrollItemStore.getPayrollItems());
                    }),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private service: EmployeeBaseRateService,
        private entityServices: EntityServices,
        private store: Store
    ) {
        this.employeePayrollItemDS =
            this.entityServices.getEntityCollectionService<fromDataServices.EmployeePayrollItem.EmployeePayrollItemModel>(
                fromDataServices.EmployeePayrollItem.entityName
            );
        this.employeeDS =
            this.entityServices.getEntityCollectionService<fromDataServices.ManageUsers.LoginModel>(
                fromDataServices.ManageUsers.entityName
            );
    }
}
